<dx-button type="default" stylingMode="contained" [disabled]="!allowDatamarsSubmit" class="btn w-100" icon="fal fa-tags"
    [text]="caption" (click)="executeDataMarsRequest()">
</dx-button>